/** Period keys for reception appointment board. */
export const RECEPTION_PERIODS = [
  { key: 'today', label: 'Today' },
  { key: 'tomorrow', label: 'Tomorrow' },
  { key: 'yesterday', label: 'Yesterday' },
  { key: 'this_week', label: 'This week' },
  { key: 'next_week', label: 'Next week' },
  { key: 'this_month', label: 'This month' },
];

export const STATUS_FILTERS = [
  { key: 'all', label: 'All' },
  { key: 'triage', label: 'Triage' },
  { key: 'unpaid', label: 'Payment due' },
  { key: 'awaiting', label: 'Awaiting doctor' },
];
